import React, { useState, useRef, useEffect } from 'react';
import StyledInput from '../styledInput/StyledInput';

/**
 * Composant FilterDropdown réutilisable pour les filtres avec dropdown
 * Utilise StyledInput en interne pour un style cohérent avec hover grey-100
 * 
 * @param {string|ReactNode} value - Valeur affichée sur le bouton (peut être une string ou un élément React comme une icône)
 * @param {Array} list - Liste des options avec {value, label, checked}
 * @param {Function} onChange - Fonction appelée lors du changement
 * @param {string} type - Type de sélection: 'selectMultipleCheckbox' ou 'selectMultipleRadio'
 * @param {string} className - Classes CSS additionnelles pour le wrapper
 * @param {string} maxWidth - Largeur maximale (ex: 'max-w-[155px]')
 * @param {boolean} showChevron - Afficher le chevron (par défaut true)
 * @param {Object} additionalProps - Props additionnelles à passer à StyledInput
 */
const FilterDropdown = ({
  value,
  list,
  onChange,
  type = 'selectMultipleCheckbox',
  className = '',
  maxWidth = '',
  showChevron = true,
  classNameValue,
  showCheck,
  ...additionalProps
}) => {
  // Si value est un élément React (icône), ajuster le padding et désactiver le check
  const isIcon = React.isValidElement(value);
  const finalClassNameValue = classNameValue || (isIcon ? 'px-4 py-2 flex items-center justify-center' : undefined);
  // Désactiver le check pour les icônes (priorité sur showCheck explicite sauf si défini)
  const finalShowCheck = showCheck !== undefined ? showCheck : (isIcon ? false : true);
  
  // Extraire showCheck de additionalProps s'il existe pour éviter les conflits
  const { showCheck: _, ...restAdditionalProps } = additionalProps;
  
  return (
    <div className={`min-w-0 ${maxWidth} ${className}`}>
      <StyledInput
        type={type}
        value={value}
        list={list}
        onChange={onChange}
        showChevron={showChevron}
        classNameValue={finalClassNameValue}
        {...restAdditionalProps}
        showCheck={finalShowCheck}
      />
    </div>
  );
};

export default FilterDropdown;

